import { getCoprincipalMailboxInfo } from 'owa-account-source-list-store';
import { IsShareableCRUDEnabled } from 'owa-groups-shared-store/lib/utils/shareableCRUDFlight';
import { lazyCreateGroup } from 'owa-group-create-integration';
import { lazyCreateGroupV2 } from 'owa-group-create-integration-v2';
import { initializeUserSettings } from 'owa-groups-adaptors';
import { lazyGroupsDiscover, UserType } from 'owa-groups-discover-integration';
import { getCurrentCulture, getCurrentLanguage } from 'owa-localize';
import { getRibbonMailboxInfo } from 'owa-mail-ribbon-utils/lib/getRibbonMailboxInfo';
import type { RibbonControlDefinitionProps } from 'owa-mail-ribbon-utils';
import { getAccountScopeUserSettings } from 'owa-session-store';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { lazyOpenGroupsPanel } from 'owa-groups-panel-actions';

export async function openCreateGroup(props: RibbonControlDefinitionProps): Promise<void> {
    const mailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);

    if (IsShareableCRUDEnabled(mailboxInfo)) {
        const createGroup = await lazyCreateGroupV2.import();
        const sessionSettings = getAccountScopeUserSettings(mailboxInfo).SessionSettings;

        if (sessionSettings?.ExternalDirectoryUserGuid) {
            createGroup(
                sessionSettings.ExternalDirectoryUserGuid,
                getCurrentLanguage(),
                getCurrentCulture(),
                'Ribbon',
                mailboxInfo
            );
        }
    } else {
        const createGroup = await lazyCreateGroup.import();
        createGroup(
            isConsumer(undefined, mailboxInfo) ? UserType.Consumer : UserType.Enterprise,
            getCurrentCulture(),
            'Ribbon',
            mailboxInfo
        );
    }
}

export const openDiscoverGroups = async (props: RibbonControlDefinitionProps): Promise<void> => {
    const discoverGroups = await lazyGroupsDiscover.import();
    const moduleMailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);
    const accountMailboxInfo = getCoprincipalMailboxInfo(moduleMailboxInfo);
    const userSmtp = accountMailboxInfo
        ? getAccountScopeUserSettings(accountMailboxInfo).SessionSettings?.UserEmailAddress
        : undefined;

    if (userSmtp) {
        initializeUserSettings(userSmtp, getCurrentCulture());
        discoverGroups(
            UserType.Enterprise,
            getCurrentCulture(),
            'MailRibbon',
            /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion  -- (https://aka.ms/OWALintWiki)
             * Non-null assertions are dangerous, as they can hide bugs from strictness checks. Please remove this usage or replace this line with a justification.
             *	> Forbidden non-null assertion. */
            accountMailboxInfo!
        );
    }
};

export function openGroupsPanel(): void {
    lazyOpenGroupsPanel.importAndExecute('MailRibbon');
}
